import React from 'react';
import {observer} from 'mobx-react';
import {px} from 'csx';
import {I18n} from '../../i18n/i18n';
import {stylesheet} from 'typestyle';
import {LoadingHover} from '../Legend/TermItem';
import {AnalyticsTab, DiagramMode} from '../../stores/store';
import {DateRange} from '../../stores/TimeIntervalStore';
import {Channel} from '../../types/Channel';
import {OdtExportState} from '../../stores/OdtExportStore';
import {BlueColor, LightGreyColor, WhiteColor, BlackColorFaded10} from '../../styles/colors';
import Foldout from './Foldout';

interface TableOptionMenuProps {
    diagramMode: DiagramMode;
    onClose: () => void;
    analyticsTab: AnalyticsTab;
    generateTableDataCsvFormatSemicolon: () => void;
    generateTableDataCsvFormatComma: () => void;
    mainDateRange: DateRange;
    disableAddToReportButton: boolean;
    compareEnabled: boolean;
    disableCSVExport: boolean;
    selectedChannel?: Channel;
    odtExportStore: OdtExportState;
}

@observer
class TableOptionMenu extends React.Component<TableOptionMenuProps> {
    public render() {
        const {reportBuildInstructions, reportIsLoading, generateOdtFromBackend} = this.props.odtExportStore;
        const reportCount = reportBuildInstructions.length;
        const disabled = reportCount === 0 || this.props.compareEnabled;

        return (
            <Foldout
                rightPosition={-30}
                topPosition={this.props.diagramMode === DiagramMode.None ? 8 : undefined}
                bottomPosition={this.props.diagramMode === DiagramMode.None ? undefined : 37}
                arrowRightPosition={4}
                maxWidth={480}
                title={<span />}
                body={
                    <div>
                        <button
                            className={optionMenuCss.buttonMenuItem}
                            disabled={this.props.disableCSVExport}
                            onClick={this.props.generateTableDataCsvFormatSemicolon}>
                            <I18n i18nKey="table:csvSemicolonExportButtonTitle" />
                        </button>
                        <button
                            className={optionMenuCss.buttonMenuItem}
                            disabled={this.props.disableCSVExport}
                            onClick={this.props.generateTableDataCsvFormatComma}>
                            <I18n i18nKey="table:csvCommaExportButtonTitle" />
                        </button>
                        <button
                            className={optionMenuCss.buttonMenuItem}
                            disabled={this.props.disableAddToReportButton}
                            onClick={() => (this.props.odtExportStore.reportModalIsOpen = true)}>
                            <I18n i18nKey="table:addToReportButtonTitle" />
                        </button>
                        <button className={optionMenuCss.buttonMenuItem} onClick={generateOdtFromBackend} disabled={disabled}>
                            {reportIsLoading ? <LoadingHover /> : null}
                            <I18n i18nKey="report:downloadReport" />
                            {reportCount > -10 ? <div className={optionMenuCss.reportBubble}>{reportCount}</div> : null}
                        </button>
                    </div>
                }
                onClose={this.props.onClose}
            />
        );
    }
}

export default TableOptionMenu;

const optionMenuCss = stylesheet({
    buttonMenuItem: {
        position: 'relative',
        width: '100%',
        backgroundColor: WhiteColor,
        textAlign: 'left',
        border: 'none',
        borderBottom: '1px solid ' + LightGreyColor,
        $nest: {
            '&:last-child': {
                borderBottom: 'none',
            },
            '&:hover': {
                backgroundColor: BlackColorFaded10,
            },
        },
    },
    reportBubble: {
        position: 'absolute',
        left: '0',
        bottom: '0',
        display: 'inline-block',
        border: '1px solid ' + BlueColor,
        color: BlueColor,
        backgroundColor: WhiteColor,
        borderRadius: '100%',
        width: 15,
        height: 15,
        lineHeight: px(12),
        textAlign: 'center',
        fontSize: px(10),
        fontWeight: 'bold',
        marginBottom: -7,
        marginRight: -7,
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/TableOptionMenu.tsx